// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2aB6t"};